{
  "header": {
    "logoAlt": "MetaDevProfile",
    "brandName": "MetaDevProfile",
    "home": "Home",
    "contactUs": "Contact us"
  },
  "signIn": {
    "title": "Welcome back",
    "description": "Login to your MetaDevProfile account",
    "email": "Email",
    "emailPlaceholder": "m@example.com",
    "password": "Password",
    "passwordPlaceholder": "********",
    "forgotPassword": "Forgot your password?",
    "signInButton": "Login",
    "noAccount": "Don't have an account?",
    "signUpLink": "Sign up",
    "disclaimer": "By clicking continue, you agree to our",
    "termsOfUse": "Terms of Use",
    "and": "and",
    "privacyPolicy": "Privacy Policy",
    "logoAlt": "Sign in background",
    "brandName": "MetaDevProfile",
    "testimonialAuthor": "Olivier Gorgy",
    "testimonialQuote": "MetaDevProfile has transformed how I manage my practice. The interface is intuitive and the features are exactly what I needed.",
    "jobTitle": "Liberal Practitioner, Sensoted"
  },
  "signUp": {
    "title": "Create an account",
    "description": "Create an account to get started",
    "type": "Type",
    "typePractitioner": "Practitioner",
    "typePractitionerDescription": "You run evaluations with your patients (individual account, mobile app)",
    "typeInstitution": "Institution",
    "typeInstitutionDescription": "You manage a facility and create access for your practitioners (no evaluation from this account)",
    "email": "Email",
    "emailPlaceholder": "m@example.com",
    "password": "Password",
    "passwordPlaceholder": "********",
    "passwordHint": "Min. 12 characters, 1 uppercase, 1 lowercase, 1 digit, 1 special character",
    "confirmPasswordPlaceholder": "********",
    "confirmPassword": "Confirm Password",
    "signUpButton": "Sign Up",
    "alreadyHaveAccount": "Already have an account?",
    "signInLink": "Sign in",
    "disclaimer": "By clicking continue, you agree to our",
    "termsOfUse": "Terms of Use",
    "and": "and",
    "privacyPolicy": "Privacy Policy",
    "logoAlt": "Sign up background",
    "brandName": "MetaDevProfile",
    "testimonialAuthor": "Olivier Gorgy",
    "testimonialQuote": "MetaDevProfile has transformed how I manage my practice. The interface is intuitive and the features are exactly what I needed.",
    "jobTitle": "Liberal Practitioner, Sensoted"
  },
  "forgotPassword": {
    "title": "Forgot your password?",
    "description": "Enter your email to reset your password",
    "email": "Email",
    "emailPlaceholder": "m@example.com",
    "sendButton": "Send reset link",
    "rememberPassword": "Remember your password?",
    "signInLink": "Sign in"
  },
  "resetPassword": {
    "title": "Reset your password",
    "description": "Enter your new password below",
    "password": "New Password",
    "passwordHint": "Min. 12 characters, 1 uppercase, 1 lowercase, 1 digit, 1 special character",
    "confirmPassword": "Confirm New Password",
    "resetButton": "Reset Password",
    "rememberPassword": "Remember your password?",
    "signInLink": "Sign in"
  },
  "verifyOtp": {
    "title": "Two-step verification",
    "description": "A verification code has been sent to your email address",
    "codeLabel": "Verification code",
    "codePlaceholder": "000000",
    "verifyButton": "Verify",
    "resendButton": "Resend code",
    "resendIn": "Resend in {{seconds}}s",
    "backToSignIn": "Back to sign in"
  },
  "errors": {
    "changePasswordFailed": "Failed to change password",
    "forgotPasswordFailed": "Failed to send reset email",
    "resetPasswordFailed": "Failed to reset password",
    "signInFailed": "Sign in failed",
    "accountLocked": "Account temporarily locked due to too many attempts",
    "otpVerificationFailed": "Verification code failed",
    "otpResendFailed": "Failed to resend code",
    "signUpFailed": "Sign up failed",
    "signOutFailed": "Failed to sign out",
    "fetchCurrentUserFailed": "Failed to load the current user"
  },
  "success": {
    "signedOut": "Successfully signed out",
    "signedIn": "Signed in successfully",
    "signedUp": "Signed up successfully",
    "otpResent": "A new verification code has been sent",
    "forgotPasswordSent": "If the email exists, a reset link has been sent",
    "passwordReset": "Password reset successfully",
    "passwordChanged": "Password changed successfully"
  },
  "passwordCriteria": {
    "minLength": "12 characters minimum",
    "lowercase": "1 lowercase letter",
    "uppercase": "1 uppercase letter",
    "digit": "1 digit",
    "specialChar": "1 special character"
  }
}
